module.exports = __webpack_public_path__ + "img/jevon_holland.970d9aaf.png";